import { useUserInterfaceStore } from "../../store";

import RoomEditing from "./RoomEditing.js";
import RoomGeometry from "./RoomGeometry.js";

function RoomEditor() {
  const editingRoom = useUserInterfaceStore((s) => s.editingRoom);
  return <>{editingRoom ? <RoomEditing /> : <RoomGeometry />}</>;
}

export default RoomEditor;
